export const ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS'
export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS'
export const VIEW_NOTIFICATIONS = 'VIEW_NOTIFICATIONS'

export const SET_CHANNEL_NOTIFICATION_READ_DATE = 'SET_CHANNEL_NOTIFICATION_READ_DATE'
export const SET_GLOBAL_NOTIFICATION_READ_DATE = 'SET_GLOBAL_NOTIFICATION_READ_DATE'
